import { apiFetch } from './utils/api';

// Named analyticsEvents, not events: api/events.js (v2 calendar events) already
// owns `events` in the api barrel.
export const analyticsEvents = {
  post: (events) =>
    apiFetch('/v3/analytics/events', {
      method: 'POST',
      body: JSON.stringify({ events }),
      keepalive: true,
    }),
};
